import { useDrawer } from 'components/drawers/inc-drawer/inc-drawer.hooks';
import { EmailTemplateDrawerDataType } from './email-template-drawer.component';

export const useEmailTemplateDrawer = () =>
  useDrawer<EmailTemplateDrawerDataType>();
